import { defineStore } from 'pinia';
export const useWidgetStore = defineStore('widget', {
    state: () => ({
      widgetInfo: {
        widgetType: '',
      }
    }),
    actions: {
      setWidgetType(text) {
        this.widgetInfo.widgetType = text;
      },
      getWidgetInfo() {
        return this.widgetInfo;
      }
    }
  });
  